import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateFamilyMembersRequest,
  CreateFamilyMembersResponse
} from '@model/family-member/create-family-members.model';


export interface FamilyMembersPort {

  createFamilyMembers(
    request: CreateFamilyMembersRequest
  ): Observable<CreateFamilyMembersResponse>;
}

export const FAMILY_MEMBERS_PORT = new InjectionToken<FamilyMembersPort>(
  'FamilyMembersPort'
);
